import BaseModel from './base';
import CertificateProfile from './certificate-profile';
import User from '@/utils/user';

export const REQUEST_STATUS = {
  outsider: null,
  waiting: 1,
  accept: 2,
  cancelOrganizer: 3,
  cancelExpert: 4,
  awaitingActivation: 5,
};

export const REQUEST_STATUS_DATA = {
  [REQUEST_STATUS.waiting]: {
    id: REQUEST_STATUS.waiting,
    name: 'Ожидает подтверждения',
    attrs: {
      color: 'warning',
    },
    icon: '$iclock-outline',
  },
  [REQUEST_STATUS.accept]: {
    id: REQUEST_STATUS.accept,
    name: 'Управляется экспертом',
    attrs: {
      color: 'redesignSuccess',
    },
    icon: '$icheck',
  },
  [REQUEST_STATUS.cancelExpert]: {
    id: REQUEST_STATUS.cancelExpert,
    name: 'Отменен экспертом',
    attrs: {
      color: 'redesignError',
    },
    icon: '$iclose',
  },
  [REQUEST_STATUS.cancelOrganizer]: {
    id: REQUEST_STATUS.cancelOrganizer,
    name: 'Отменен вами',
    attrs: {
      color: 'redesignError',
    },
    icon: '$iclose',
  },
  [REQUEST_STATUS.awaitingActivation]: {
    id: REQUEST_STATUS.awaitingActivation,
    name: 'Временно управляется вами',
    attrs: {
      color: 'warning',
    },
    icon: '$iclock-outline',
  },
  [REQUEST_STATUS.outsider]: {
    id: REQUEST_STATUS.outsider,
    name: 'Внешний эксперт',
    attrs: {
      color: undefined,
    },
    icon: undefined,
  },
};

export default class Expert extends BaseModel {
  #user;

  constructor(expert, url) {
    super(expert, url);

    this.profile = new CertificateProfile(expert?.profile || {});
    this.departament = expert?.departament || null;
    this.created_at = expert?.created_at || null;
    this.requests = expert?.requests || [];
    this.roles = expert?.roles || [];
    this.username = expert?.username || '';
    this.nomination_ids = expert?.nomination_ids || [];
    this.timezone = expert?.timezone || null;
    this.invite_code = expert?.invite_code || null;
    this.organization = expert?.organization || [];

    this.organizer = null;

    this.#user = new User();
  }

  get isMineExpert() {
    return this.organization.some((i) => i.id === this.#user?.data?.organizer?.id);
  }

  initOrganizerData(organizerId) {
    const request = this.getOrganizerRequest(organizerId);

    this.organizer = {
      id: this.isMineExpert ? organizerId : null,

      request: {
        id: request?.request_id || null,
        status: this.getOrganizerRequestStatus(organizerId),
      },
    };
  }

  getOrganizerRequest(organizerId) {
    return this.requests.find((i) => i.organizer_id === organizerId) || null;
  }

  getOrganizerRequestStatus(organizerId) {
    const { invite_code } = this;
    const request = this.getOrganizerRequest(organizerId);
    const status = request?.status || null;

    // Если есть инвайт-код, то значит временно управляется вами
    if (invite_code) return REQUEST_STATUS_DATA[REQUEST_STATUS.awaitingActivation];

    // Иначе отдаем значение по глоссарию
    return REQUEST_STATUS_DATA[status] || null;
  }
}
